import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDifferenceIgnored: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="difference-ignored"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8.5 15.5L15.5 8.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconDifferenceIgnored;
